import { render, staticRenderFns } from "./TheSearch.vue?vue&type=template&id=19da9604&scoped=true"
import script from "./TheSearch.vue?vue&type=script&lang=js"
export * from "./TheSearch.vue?vue&type=script&lang=js"
import style0 from "./TheSearch.vue?vue&type=style&index=0&id=19da9604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19da9604",
  null
  
)

export default component.exports